module.exports = __webpack_public_path__ + "static/media/WhatsAppIcon.3ea2e8d5.svg";